const { get } = require("lodash");
import { getAppFeatureProp } from "@/utilities/app-feature-util";
import store from "@/store";

import { Constants } from "customer-sdk/constants";
const COMPANY_USER_ACCESS_ROLES = Constants.COMPANY_USER_ACCESS_ROLES;

/**
 * @class AppAccessUtil
 * @description util used for app access
 * @author Edmark Santos
 * @version 1.0
 * @since May 10, 2021
 */

export function getAppAccessOptions() {
  let appAccessOptions = {
    country_code: "",
    domain_url: "",
  };
  let countrycode = get(store.state.configModule, "platformConfig.country_code", "");
  let domainUrl = get(store.state.configModule, "platformConfig.domain_url", "");
  appAccessOptions = {
    country_code: countrycode,
    domain_url: domainUrl,
  };
  return appAccessOptions;
}

export function validateUserPermission(userId, companyUsers = [], permittedRoles = []) {
  return companyUsers.some((cUser) => {
    if (cUser.user._id.toString() == userId && permittedRoles.length > 0) {
      return permittedRoles.some((role) => get(cUser, role));
    }
    return false;
  });
}

export function getPermittedRoles(permittedRoles) {
  const { DIRECTOR, SHAREHOLDER } = COMPANY_USER_ACCESS_ROLES;

  const platformConfig = store.state.configModule.platformConfig;
  const postPaymentGeneralFeatureList = getAppFeatureProp(platformConfig.cmsGeneralFeatureList, "post_payment");
  const directorAccessEnabled = getAppFeatureProp(postPaymentGeneralFeatureList.props, "director_access").enabled;
  const shareholderAccessEnabled = getAppFeatureProp(postPaymentGeneralFeatureList.props, "shareholder_access").enabled;

  if (!permittedRoles || permittedRoles.length === 0) return [];

  if (!directorAccessEnabled) {
    permittedRoles = permittedRoles.filter((role) => role != DIRECTOR);
  }
  if (!shareholderAccessEnabled) {
    permittedRoles = permittedRoles.filter((role) => role != SHAREHOLDER);
  }

  return permittedRoles;
}

module.export = {
  getAppAccessOptions,
  validateUserPermission,
  getPermittedRoles,
};
